<template>
    <div v-if="enabled" class="popup">
        <div class="popup-inner">
            <slot name="content" />
            <div class="popup-controls">
                <slot name="controls" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            enabled: {
                type: Boolean,
                default: true,
                required: false
            }
        }
    }
</script>

<style lang="scss">
    @import '../styles/base';
    @import '../../node_modules/hd-styles/base';

    .popup {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
        background-color: rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .popup-inner {
        background: $white;
        padding: 32px;
        max-width: 80%;
    }

    .popup-controls {
        text-align: right;
    }

    .button {
        margin-left: $spacing-unit;
    }
</style>
